import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { SidebarComponent } from './sidebar.component';
import { CommonModule } from '@angular/common';
import { MyCalendarModule } from '../calendar';

@NgModule({
    imports: [RouterModule, CommonModule, MyCalendarModule],
    declarations: [SidebarComponent],
    exports: [SidebarComponent],
})

export class SidebarModule {}
